import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import styles from './HFInputs.module.sass'
import HFTextInput from './HFTextInput'
import HFDropdown from './HFDropdown'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useWatch } from 'react-hook-form'
import { useFetchList } from 'store'
import { Options } from 'models'

const HFAppointmentProtocolRow = (props) => {
	const {
		name,
		index,
		processId,
		totalAppointmentsForSpecialty,
		medicalSpecialties,
		remove,
	} = props
	const { i18n } = useGlobal()
	const specialtyId = useWatch({ name: `${name}.${index}.specialtyId` })

	const providerEntitiesUri =
		specialtyId &&
		`/metadata/service_providers/appointment_specialty/${specialtyId}/${processId}`

	const { contents, state } = useFetchList(
		[providerEntitiesUri],
		[Options.fromSimpleObjectJSON]
	)
	const isLoading = state === 'loading'
	const [providerEntities = []] = contents || []

	const providerEntitiesOptions = isLoading
		? [{ value: '', text: i18n`Loading...` }]
		: [{ value: '', text: i18n`None` }, ...(providerEntities || [])]

	return (
		<HStack
			wrap='nowrap'
			gap='xsmall'
			className={styles['process-protocol-field']}
		>
			<HStack gap='small' columns={['75px', 4, 4]}>
				<HStack className={styles['quantity-container']}>
					<small>({totalAppointmentsForSpecialty})</small>

					<HFTextInput
						name={`${name}.${index}.quantity`}
						type='number'
						placeholder=''
						displaySuffixIcon={false}
						inputMode={'numeric'}
						multiline={false}
						noResize
						ignoreCustomValidity={false}
					/>
				</HStack>
				<div>
					<HFDropdown
						name={`${name}.${index}.specialtyId`}
						options={medicalSpecialties || []}
						searchable={true}
						noData={i18n`No results`}
					/>
				</div>
				<div>
					<HFDropdown
						name={`${name}.${index}.serviceProviderId`}
						options={providerEntitiesOptions || []}
						searchable={true}
						noData={i18n`No results`}
					/>
				</div>
			</HStack>
			<Icon
				className={styles['remove-button']}
				onClick={(e) => {
					e.preventDefault()
					remove(index)
				}}
				name='minus'
				height='12px'
				width='12px'
			/>
		</HStack>
	)
}

export default HFAppointmentProtocolRow
